module.exports = [{"id":0,"title":"Кроме битых","value":0},{"id":1,"title":"После ДТП","value":1},{"id":null,"title":"Неважно","value":null}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/states.json
// module id = 1153
// module chunks = 49